import { SkyscannerHotelunifiedbffHotelcontentV1HotelContent } from '@skyscanner-internal/hotel-unified-bff-web-http-client';

import type { HotelContent } from '../../selectors/michelinTypes';

const PATH_PREFIX = '/g/hotel-unified-bff';
const REQUESTED_FIELDS = {
  paths: [
    { path: 'PATH_DISTANCE' as const },
    { path: 'PATH_NAME' as const },
    { path: 'PATH_REVIEW_SUMMARY' as const },
    { path: 'PATH_GALLERY_IMAGE' as const },
  ],
};

/**
 * Fetches hotel content (name, stars, gallery, reviews, location, distance)
 * for a given hotel ID. The BFF automatically resolves the hotel's city
 * and returns distance from city centre via PATH_DISTANCE.
 *
 * @param {string} hotelId - Hotel entity ID to fetch content for
 * @param {string} locale - Locale code (e.g. 'en-GB')
 * @param {string} market - Market code (e.g. 'UK')
 * @param {string} currency - Currency code (e.g. 'GBP')
 * @param {AbortSignal} [signal] - Optional cancellation signal
 * @returns {Promise<HotelContent | undefined>} Hotel content or undefined if not found
 */
export const getHotelContent = async (
  hotelId: string,
  locale: string,
  market: string,
  currency: string,
  signal?: AbortSignal,
): Promise<HotelContent | undefined> => {
  const response =
    await SkyscannerHotelunifiedbffHotelcontentV1HotelContent.HotelContentService.GetHotelContent(
      {
        hotelId,
        locale,
        market,
        currency,
        requestedFields: REQUESTED_FIELDS,
      },
      {
        pathPrefix: PATH_PREFIX,
        headers: {
          'Content-Type': 'application/json',
          'x-user-agent': 'D;Web',
        },
        signal,
      },
    );

  return response.hotel;
};
